import React from "react";
import { Avatar, Box, Card, CardContent, CardHeader, Chip, Stack, Typography } from "@mui/material";

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export default function ProgramCard({ program, formatCurrency }) {
  const original = toNumber(program?.original_price);
  const discounted = toNumber(program?.discounted_price || original);
  const discount = toNumber(program?.discount_percentage);
  const hasDiscount = discount > 0 && discounted < original;

  return (
    <Card variant="outlined">
      <CardHeader
        avatar={
          program?.logo_url ? (
            <Avatar src={program.logo_url} alt={program?.name} />
          ) : (
            <Avatar>{program?.name?.charAt(0) || "P"}</Avatar>
          )
        }
        title={program?.name || "Program"}
        subheader={program?.website || null}
      />
      <CardContent sx={{ pt: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {hasDiscount ? (
            <>
              <Typography sx={{ textDecoration: "line-through", color: "text.secondary" }}>
                {formatCurrency ? formatCurrency(original) : original}
              </Typography>
              <Typography sx={{ color: "success.main", fontWeight: 700 }}>
                {formatCurrency ? formatCurrency(discounted) : discounted}
              </Typography>
              <Chip size="small" color="error" label={`${discount}% OFF`} />
            </>
          ) : (
            <Typography sx={{ fontWeight: 700 }}>
              {formatCurrency ? formatCurrency(original) : original}
            </Typography>
          )}
        </Stack>
        {program?.description ? (
          <Box sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              {program.description}
            </Typography>
          </Box>
        ) : null}
      </CardContent>
    </Card>
  );
}

